import { render, staticRenderFns } from "./m-fab.vue?vue&type=template&id=7b8e8c34"
import script from "./m-fab.vue?vue&type=script&lang=js"
export * from "./m-fab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports